import React from 'react';

import { Row, Col } from 'reactstrap';

const Footer = () => {
  return (
    <footer className='footer' style={{ marginTop: '50vh' }}>
      <Row className='align-items-center justify-content-xl-between'>
        <Col xl='6'>
          <div className='copyright text-center text-xl-left text-muted'>
            © {new Date().getFullYear()}
            {'  DNG'}
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
